import type { SproutReceipt } from './types'

export function sproutRequestState(receipts: SproutReceipt[]) {
  const latest = [...receipts].sort((a, b) => (b.request_sequence || 0) - (a.request_sequence || 0)
    || (b.created_at || '').localeCompare(a.created_at || '') || b.job_id.localeCompare(a.job_id))[0]
  return {
    previousJobId: latest?.job_id || null,
    hasDelivered: receipts.some(item => ['delivered', 'deleted'].includes(item.status)),
    blocked: receipts.some(item => item.reconciliation_required || (!['delivered', 'deleted'].includes(item.status) && !item.can_replace)),
  }
}
